// DS9.8M
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import TierIcon from '@wix/da-ds/pkg/Icons/Tier';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowDown';
import ArrowUpIcon from '@wix/da-ds/pkg/Icons/ArrowUp';
import Flex from '@wix/da-ds/pkg/Flex';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { hashString } from '../../../utils/hash';
import StatisticsBar from '../../Helper/StatisticsBar';
import Benefits from '../Benefits';
import { formatPrice } from '../utils';
import MediaService, { fallbackToLargestFile, } from '../../../utils/DeviationMediaService';
import s from './TierProductCardDumbMobile.scss';
var THUMB_WIDTH = 360;
var THUMB_HEIGHT = 140;
var TierProductCardDumbMobile = function (_a) {
    var coverImage = _a.coverImage, title = _a.title, tierState = _a.tierState, stats = _a.stats, ctaButton = _a.ctaButton, description = _a.description, _b = _a.price, price = _b === void 0 ? '' : _b, _c = _a.benefits, benefits = _c === void 0 ? [] : _c, info = _a.info, withExpandButton = _a.withExpandButton, coverAreaExtrasLeft = _a.coverAreaExtrasLeft, coverAreaExtrasRight = _a.coverAreaExtrasRight, isHighlighted = _a.isHighlighted, className = _a.className, onClick = _a.onClick, onToggleCollapsed = _a.onToggleCollapsed, isCollapsedProp = _a.isCollapsed, innerRef = _a.innerRef;
    var t = useTranslation().t;
    var _d = useState(false), isCollapsedState = _d[0], setIsCollapsed = _d[1];
    var isControlled = isCollapsedProp !== undefined;
    var isCollapsed = isControlled ? isCollapsedProp : isCollapsedState;
    var hasBenefits = benefits.length > 0;
    var isCollapsible = withExpandButton && hasBenefits;
    var benefitsHash = hashString("benefits.".concat(benefits.join('|')));
    var toggleCollapsed = useCallback(function () {
        if (isControlled) {
            onToggleCollapsed && onToggleCollapsed(!isCollapsed);
        }
        else {
            setIsCollapsed(!isCollapsed);
        }
    }, [onToggleCollapsed, isControlled, isCollapsed]);
    var preview = coverImage &&
        MediaService.getSmallestThumbThatFullyCovers(coverImage, THUMB_WIDTH, THUMB_HEIGHT, fallbackToLargestFile, {
            allowPreview: true,
            allowFullview: false,
        });
    return (React.createElement(Flex, { className: classnames(s['root'], isHighlighted && s['root-highlight'], onClick && s['clickable-root'], className), direction: "column", onClick: onClick, innerRef: innerRef },
        React.createElement("div", { className: s['header'] },
            React.createElement("div", { className: s['cover-wrapper'] },
                React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
                    coverAreaExtrasLeft && (React.createElement("div", { className: s['cover-area-extras-left'] }, coverAreaExtrasLeft)),
                    coverAreaExtrasRight && (React.createElement("div", { className: s['cover-area-extras-right'] }, coverAreaExtrasRight)),
                    preview ? (React.createElement("div", { className: s['cover'], style: {
                            width: '100%',
                            height: THUMB_HEIGHT,
                            backgroundImage: "url('".concat(preview.src, "')"),
                            backgroundRepeat: 'no-repeat',
                            backgroundPositionX: 'center',
                            backgroundPositionY: 'center',
                            backgroundSize: 'cover',
                        } })) : (React.createElement("div", { className: classnames(s['cover'], s['placeholder-cover']), style: { width: '100%', height: THUMB_HEIGHT } })),
                    React.createElement("div", { className: s['cover-overlay'] },
                        title && React.createElement(Heading, { className: s['title'] }, title),
                        stats && (React.createElement(StatisticsBar, { className: s['stats'], stats: [
                                stats.subscribers !== undefined && {
                                    icon: TierIcon,
                                    label: t('deviationview.tierCard.subscribers', {
                                        count: stats.subscribers,
                                    }),
                                },
                            ] })))))),
        React.createElement("div", { className: s['card-body'] },
            price && (React.createElement("div", { className: s['price-block'] },
                React.createElement("span", { className: s['price'] }, formatPrice(price)),
                React.createElement("span", { className: s['price-period'] },
                    "/",
                    t('deviationview.tierCard.pricePeriod.month')))),
            ctaButton && React.createElement("div", { className: s['cta-button'] }, ctaButton),
            React.createElement("div", { className: classnames(s['collapsible'], isCollapsed && s['collapsed']) },
                description && (React.createElement("div", { className: classnames(s['description'], !hasBenefits && s['no-benefits']) }, description)),
                hasBenefits && React.createElement(Benefits, { key: benefitsHash, benefits: benefits }))),
        React.createElement("div", { className: s['card-footer'] },
            info && (React.createElement("div", { className: classnames(s['collapsible'], isCollapsed && s['collapsed']) },
                React.createElement("hr", { className: s['divider'] }),
                React.createElement(Flex, { className: s['info-block'], alignItems: "flex-start" },
                    React.createElement(InfoIcon, { size: IconSize.SMALLER, className: s['info-icon'], disableDefaultColors: true }),
                    React.createElement("div", { className: s['info'] }, info)))),
            isCollapsible && (React.createElement(React.Fragment, null,
                React.createElement("hr", { className: s['divider'] }),
                React.createElement(PlainButtonOrLink, { onClick: toggleCollapsed, className: s['toggle-button'] },
                    React.createElement("span", { className: s['toggle-button-label'] }, isCollapsed
                        ? t('deviationview.tierCard.showMore')
                        : t('deviationview.tierCard.showLess')),
                    isCollapsed ? (React.createElement(ArrowDownIcon, { size: IconSize.SMALLER, disableDefaultColors: true })) : (React.createElement(ArrowUpIcon, { size: IconSize.SMALLER, disableDefaultColors: true }))))))));
};
TierProductCardDumbMobile.displayName = 'TierProductCardDumbMobile';
export default TierProductCardDumbMobile;
//# sourceMappingURL=TierProductCardDumbMobile.js.map